export class tbl_auftrag_flags {
    static readonly flag_Auftrag_Vorgemerkt_Gefaessabmeldung: number = (1 << 0);
}